module.exports = __webpack_public_path__ + "img/graduationCeremony.d13d6263.jpg";